export type FormDataOption = {
  label: string;
  value: string;
};

export const transformArrayToFormData = (data: string[]): FormDataOption[] => {
  return data.map((item: string) => {
    return { label: item, value: item };
  });
};
